/**
 * titleCase:
 * Titlecases a given string
 *
 * @param str
 * @returns {*|string|void}
 */
export default (str) => {
  return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
};
